let flippedCards = 0;

giftImages = [
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Cleaner_Cloth_Single.png?v=1786581172",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Dishwashing_Machine_Cleaner_2_Pack_-_Single.png?v=1786581172",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Dish_Soap_Strips_single_-_60_Pack_3.png?v=1788760452",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Free_Tin.png?v=1788300743",
];

productImages = [
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_1.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_2.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_3.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_4.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_5.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_6.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_7.png",
];

document.body.classList.add("scroll-lock");

document.querySelectorAll(".card").forEach((card) => {
  card.addEventListener("click", () => {
    if (flippedCards < 4) {
      if (!card.classList.contains("flipped")) {
        card.classList.add("flipped");
        flippedCards = flippedCards + 1;
        card.querySelector(".card-back img").src = giftImages[flippedCards - 1];
        document.querySelector("#card-progress").textContent = flippedCards;
        document.querySelector("#card-progress-btn").textContent =
          4 - flippedCards;
      }

      if (flippedCards == 4) {
        document.querySelector(".progress-container .button").classList.remove("disabled");
        document.querySelector(".progress-container .button").innerHTML = "<span>🎁</span> Continue";
        createConfetti(giftImages);
      }

      gtag("event", "game_click", {
        game_name: "card_flip",
        card_position: parseInt(card.getAttribute("data-cardNumber")),
        cards_flipped_total: flippedCards,
      });
    }
  });
});

function closePopup() {
  document.body.classList.remove("scroll-lock");
  document.querySelector(".game-container").remove();
}

document.querySelector(".continue-button").addEventListener("click", () => {
  closePopup();
  gtag("event", "game_complete", {
    game_name: "card_flip",
  });
});

document.querySelector(".icon-close").addEventListener("click", () => {
  closePopup();
  gtag("event", "game_close", {
    game_name: "card_flip",
    close_method: "icon",
    cards_flipped_total: flippedCards,
  });
});

document.querySelector(".close-link").addEventListener("click", () => {
  closePopup();
  gtag("event", "game_close", {
    game_name: "card_flip",
    close_method: "close-text",
    cards_flipped_total: flippedCards,
  });
});
